const guestAddressListContainer = document.querySelector('#guest-address-list');
const guestAddressListWarnings = document.querySelector('#guest-address-list-warnings');
const heatResistantPopup = document.querySelector('#heatResistantPopup');
const heatResistantPopupButtons = document.querySelector('#heatResistantPopup .ohnuts-popup-buttons');
const heatResistantPopupMessageBox = document.querySelector('#heatResistantPopupMessageBox');
const addressBtnConatiner = document.querySelector('.address-btn-part');
const shipToMultiAddresseBtn = document.querySelector('#shipToMultiAddresseBtn');

const MULTI_ADDRESS_ITEM_COUNT_THRESHOLD = 1;
const SHOP_METAFIELDS_CUSTOM_AUTO_APPLY_HEAT_RESISTANT= document.querySelector('#shop_metafields_custom_auto_apply_heat_resistant').value;


subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  const cartItemCount = event?.cartData?.item_count || 0;
  if ((cartItemCount <= MULTI_ADDRESS_ITEM_COUNT_THRESHOLD)
    && addressBtnConatiner
    && shipToMultiAddresseBtn
  ) {
    const spaceNode = document.createTextNode('\u00A0');
    addressBtnConatiner.replaceChild(spaceNode, shipToMultiAddresseBtn);
  } else if ((cartItemCount > MULTI_ADDRESS_ITEM_COUNT_THRESHOLD)
    && addressBtnConatiner
    && !shipToMultiAddresseBtn
  ) {
    window.location.reload();
  }
});

document.addEventListener('DOMContentLoaded', function() {
  window.sessionStorage.removeItem(ADDRESS_REMOVAL_KEY);
	renderGuestAddressList();
  checkPreviouslyChosenAddress();
});

function renderGuestAddressList() {
  showOhnutsLoadingSpinner();
  guestAddressListContainer && (guestAddressListContainer.innerHTML = "");
  const guestAddressList = getGuestAddressList();
  if (guestAddressList.length) {
    guestAddressListWarnings && (guestAddressListWarnings.innerHTML = "");
    guestAddressList.forEach((guestAddress) => {
      document.querySelector('#guest_address_id').value = guestAddress.id;
      document.querySelector('#guest-customer-address-details').innerHTML = JSON.stringify(guestAddress);
    });
  } else {
    guestAddressListWarnings && (
      guestAddressListWarnings.innerHTML = `<h1 class="cart__empty-text">You haven't added any address yet, please add one by clicking on "Add New Address" button</h1>`
    );
  }
  removeClassesFromElements(
    '#guest-address-list-warnings',
    ['loading', 'guest-address-placeholder']
  );
  hideOhnutsLoadingSpinner();
}

function checkPreviouslyChosenAddress() {
  showOhnutsLoadingSpinner();
  let cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  if (Object.keys(cartMultiAddressList).length) {
    for (let addressId in cartMultiAddressList) {
      const targetAddress = document.querySelector(`#customer-address-${addressId}`);
      targetAddress && (targetAddress.checked = true);
    }
  }
  hideOhnutsLoadingSpinner();
}

document.addEventListener('click', function (event) {
	const target = event.target;
	const targetClassList = [...target.classList];
  if (targetClassList.indexOf('edit-address') > -1) {
    triggerAddressEdit(target)
  } else if (targetClassList.indexOf('remove-address') > -1) {
    triggerAddressRemoval(target);
  }
});

function triggerAddressEdit(target) {
  showOhnutsLoadingSpinner();
  const addressId = target.getAttribute('data-address-id');
  if (!addressId) {
    hideOhnutsLoadingSpinner();
    return showOhnutsCustomModal(
      'Address info not found!',
      'Address Error',
      'Close'
    );
  }

  const search = window.location.search;
  const redirectURL = `${ADDRESS_LIST_URL}${search}`;
  const targetURL = `${SINGLE_ADDRESS_UPDATE_URL}/${addressId}?redirect_url=${redirectURL}`;
  window.location.href = targetURL;
}

function triggerAddressRemoval(target) {
  showOhnutsLoadingSpinner();
  const addressId = target.getAttribute('data-address-id');
  if (!addressId) {
    hideOhnutsLoadingSpinner();
    return showOhnutsCustomModal(
      'Address info not found!',
      'Address Error',
      'Close'
    );
  }

  const targetAddresscard = target.closest('.address-card');
  if (!targetAddresscard) {
    hideOhnutsLoadingSpinner();
    return showOhnutsCustomModal(
      'Address info not found!',
      'Address Error',
      'Close'
    );
  }

  let addressDisplay = targetAddresscard.querySelector('.radio-txt');
  addressDisplay = addressDisplay?.innerHTML || "";
  if (addressDisplay != "") {
    addressDisplay = addressDisplay.replace(/<p>/g, '<h4>').replace(/<\/p>/g, '</h4>');
  }
  let addressInfo = targetAddresscard.querySelector(`#customer-address-${addressId}-details`);
  addressInfo = addressInfo?.innerHTML || "{}";

  try {
    JSON.parse(addressInfo);
  } catch (error) {
    console.error('Failed during parsing address : ', error);
    hideOhnutsLoadingSpinner();
    return showOhnutsCustomModal(
      'Address info not found!',
      'Address Error',
      'Close'
    );
  }

  window.sessionStorage.setItem(
    ADDRESS_REMOVAL_KEY,
    JSON.stringify({
      "address_id": addressId
    })
  );

  hideOhnutsLoadingSpinner();
  return showOhnutsCustomModal(
    addressDisplay,
    'Remove Address',
    'Confirm',
    "",
    removeSelectedAddress,
    true
  );
}

function removeSelectedAddress() {
  showOhnutsLoadingSpinner();
  let addressRemovalInfo = window.sessionStorage.getItem(ADDRESS_REMOVAL_KEY);
  if (!addressRemovalInfo) {
    hideOhnutsLoadingSpinner();
    return showOhnutsCustomModal(
      'Removal info not found!',
      'Remove Address Error',
      'Close'
    );
  }

  try {
    addressRemovalInfo = JSON.parse(addressRemovalInfo);
  } catch (error) {
    console.error('Failed during parsing address : ', error);
    hideOhnutsLoadingSpinner();
    return showOhnutsCustomModal(
      'Address removal parsing error',
      'Remove Address Error',
      'Close'
    );
  }

  const address_id = addressRemovalInfo?.address_id || null;
  if (!address_id) {
    hideOhnutsLoadingSpinner();
    return showOhnutsCustomModal(
      'Removal info not found!',
      'Remove Address Error',
      'Close'
    );
  }

  removeGuestAddressById(address_id);
  removeGuestAddressFromMultiCartList(address_id);
  afterRemovalUpdateAddressUI(address_id);
  window.sessionStorage.removeItem(ADDRESS_REMOVAL_KEY);
  hideOhnutsLoadingSpinner();
}

function removeGuestAddressFromMultiCartList(address_id) {
  let cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  if (Object.keys(cartMultiAddressList).length) {
    for (const key in cartMultiAddressList) {
      const addressDetails = cartMultiAddressList[key]?.address || null;
      const addressId = addressDetails?.id || null;
      if (addressId == address_id) {
        cartMultiAddressList[key]["address"] = {};
      }
    }
    saveOhnutsInfo(SINGLE_ADDRESS_KEY, JSON.stringify(cartMultiAddressList));
  }
}

function afterRemovalUpdateAddressUI(removed_address_id) {
  showOhnutsLoadingSpinner();
  const addressInput = document.querySelector(`#customer-address-${removed_address_id}`);
  if (addressInput) {
    const targetAddresscard = addressInput.closest('.address-card');
    targetAddresscard && targetAddresscard.remove();
    const allAddressCards = document.querySelectorAll('.address-card');
    if (!allAddressCards.length) {
      if (guestAddressListWarnings) {
        guestAddressListWarnings.innerHTML = `<h1 class="cart__empty-text">You haven't added any address yet, please add one by clicking on "Add New Address" button</h1>`;
      }

      removeClassesFromElements(
        '#guest-address-list-warnings',
        ['loading', 'guest-address-placeholder']
      );
      addClassesToElements(
        '#addAddressForShipping',
        ['loading', 'read-only']
      );
    }
  }
  hideOhnutsLoadingSpinner();
}

if (shipToMultiAddresseBtn) {
  shipToMultiAddresseBtn.addEventListener('click', (e) => {
    const showLoginWarning = shipToMultiAddresseBtn.getAttribute('data-show-login-warning');
    const redirectURL = shipToMultiAddresseBtn.getAttribute('data-url');
    if (showLoginWarning && redirectURL) {
      if (showLoginWarning == "1") {
        return showOhnutsCustomModal(
          'You must log in first for shipping to multiple addresses',
          'Multi-address Shipping',
          'Login',
          redirectURL,
          null,
          true
        );
      } else {
        showOhnutsLoadingSpinner();
        window.location.href = redirectURL;
      }
    }
  });
}

const addAddressForShipping = document.querySelector('#addAddressForShipping');
if (addAddressForShipping) {
  addAddressForShipping.addEventListener('click', async (e) => {
    const address = await savelocalstore();
    showOhnutsLoadingSpinner();
    fetch(window.Shopify.routes.root + 'cart.js')
    .then((response) => response.json())
    .then((responseJson) => {
      setInfoForShipping(address, responseJson);
    })
    .catch((e) => {
      console.error(e);
      return showOhnutsCustomModal(
        "Failed to retrieve cart data",
        "Cart Error",
        "Close",
        CART_REDIRECT_URL
      );
    })
    .finally(() => {
      hideOhnutsLoadingSpinner();
    });
  });
}

function setInfoForShipping(chosenAddress, cartJson) {
  if (!Object.keys(chosenAddress).length) {
    return showOhnutsCustomModal(
      'Address info not found!',
      'Address Error',
      'Close'
    );
  }
  const cartToken = cartJson?.token ?? null;
  const cartItems = cartJson?.items ?? null;
  if (!cartToken || !cartItems) {
    return showOhnutsCustomModal(
      "Failed to retrieve cart data",
      "Cart Error",
      "Close",
      CART_REDIRECT_URL
    );
  }
  saveOhnutsInfo(SINGLE_CART_TOKEN_KEY, cartToken);
  saveOhnutsInfo(SINGLE_CART_ITEMS_KEY, JSON.stringify(cartItems));
  let oldGiftMessage = "";
  let oldShippingRate = "";
  let oldDeliveryDate = "";
  const oldCartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  if (Object.keys(oldCartMultiAddressList).length == 1) {
    for (const key in oldCartMultiAddressList) {
      oldGiftMessage = oldCartMultiAddressList[key]?.giftMessage || oldGiftMessage;
      oldShippingRate = oldCartMultiAddressList[key]?.shippingRate || oldShippingRate;
      oldDeliveryDate = oldCartMultiAddressList[key]?.deliveryDate || oldDeliveryDate;
    }
  }
  let cartMultiAddressList = {};
  cartMultiAddressList[chosenAddress.id] = {
    "blockId": chosenAddress.id,
    "address": chosenAddress,
    "cartItems": cartItems,
    "giftMessage": oldGiftMessage,
    "shippingRate": oldShippingRate,
    "deliveryDate": oldDeliveryDate
  };
  saveOhnutsInfo(SINGLE_ADDRESS_KEY, JSON.stringify(cartMultiAddressList));
  showOhnutsLoadingSpinner();
  if(SHOP_METAFIELDS_CUSTOM_AUTO_APPLY_HEAT_RESISTANT == 'true'){
    addHeatResistantVariantsToCart(SINGLE_ADDRESS_SHIPPING_URL);
  }else{
    //hideOhnutsLoadingSpinner();
    window.location.href = SINGLE_ADDRESS_SHIPPING_URL;
  }
}

function addHeatResistantVariantsToCart(redirectURL=null) {
  showOhnutsLoadingSpinner();
  const heatResistantVariantId = getHeatResistantVariantId();
  const variantsRequiredHeatResistant = getCartVariantsRequiredHeatResistant();
  if (!heatResistantVariantId || !variantsRequiredHeatResistant) {
    if (redirectURL) {
      window.location.href = redirectURL;
      return;
    }
  }

  const targetAddressBlocks = [];
  const cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  for (const [blockId, blockDetails] of Object.entries(cartMultiAddressList)) {
    const cartItems = blockDetails?.cartItems || [];
    if (cartItems.length) {
      variantsRequiredHeatResistant.forEach((variantRequiredHeatResistant) => {
        const heatResistantRequired = cartItems.some(
          cartItem => (
            String(cartItem.variant_id) === String(variantRequiredHeatResistant)
          )
        );
        const heatResistantExists = cartItems.filter(
          cartItem => (
            String(cartItem.variant_id) === String(heatResistantVariantId)
          )
        );
        if (heatResistantRequired &&
          !heatResistantExists.length &&
          (targetAddressBlocks.indexOf(blockId) === -1)
        ) {
          targetAddressBlocks.push(blockId);
        }
      })
    }
  }

  if (!targetAddressBlocks.length) {
    if (redirectURL) {
      window.location.href = redirectURL;
      return;
    }
  }

  const items = [
    {
      "id": heatResistantVariantId,
      "quantity": targetAddressBlocks.length
    }
  ];

  const url = window.Shopify.routes.root + `cart/add.js`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'items': items
    })
  };

  hideOhnutsLoadingSpinner();
  hideHeatResistantPopupMessage();
  setHeatResistantPopupLoading();
  showHeatResistantPopup();

  fetch(url, options)
  .then((response) => response.json())
  .then((responseJson) => {
    if (areRequestItemsEqualsResponseItems(items, responseJson)) {
      const preparedResponseJson = responseJson.items.filter(
        item => item?.quantity
      ).map((item) => {
        item.quantity = 1
        return item;
      });
      addHeatResistantVariantsToAddressBlocks(
        targetAddressBlocks,
        preparedResponseJson
      );
      fetchCartDataAndUpdateAddressBlockProducts(redirectURL);
    } else {
      let errorMessage = 'Failed to add heat resistant packaging(s), please reload the page';

      if (responseJson?.status !== 200 && responseJson?.description?.length) {
        errorMessage = responseJson.description;
      }

      showHeatResistantPopupMessage(
        errorMessage,
        'error'
      );
    }
  })
  .catch((e) => {
    console.error(e);
    showHeatResistantPopupMessage(
      'Failed to add heat resistant packaging(s), please reload the page',
      'error'
    );
  })
  .finally(() => {
    resetHeatResistantPopupLoading();
  });
}

function getHeatResistantVariantId() {
  let variantId = null;
  const content = document.querySelector('#variants_required_heat_resistant');
  if (content) {
    variantId = content.getAttribute('data-heat-resistant-variant-id');
  }
  return variantId;
}

function getCartVariantsRequiredHeatResistant() {
  let variantsRequiredHeatResistant = [];
  const content = document.querySelector('#variants_required_heat_resistant')?.innerHTML;
  if (content) {
    try {
      variantsRequiredHeatResistant = JSON.parse(content);
    } catch (error) {
      console.error(
        `[getCartVariantsRequiredHeatResistant] Error parsing in JSON : ${error.message}`
      );
      variantsRequiredHeatResistant = [];
    }
  }
  return variantsRequiredHeatResistant;
}

function showHeatResistantPopup() {
  if (heatResistantPopup) {
    heatResistantPopup.style.visibility = "visible";
    heatResistantPopup.style.zIndex = "9999";
  }
}

function hideHeatResistantPopup() {
  if (heatResistantPopup) {
    heatResistantPopup.style.visibility = "hidden";
    heatResistantPopup.style.zIndex = "0";
  }
}

function setHeatResistantPopupLoading() {
  if (heatResistantPopupButtons &&
    !heatResistantPopupButtons.classList.contains('loading')
  ) {
    heatResistantPopupButtons.classList.add('loading')
  }
}

function resetHeatResistantPopupLoading() {
  if (heatResistantPopupButtons?.classList?.contains('loading')) {
    heatResistantPopupButtons.classList.remove('loading')
  }
}

function showHeatResistantPopupMessage(message='', type='success') {
  if (heatResistantPopupMessageBox) {
    heatResistantPopupMessageBox.innerHTML = message;
  }

  if (heatResistantPopupMessageBox.classList.contains('hidden')) {
    heatResistantPopupMessageBox.classList.remove('hidden')
  }

  switch (type) {
    case "success":
      if (!heatResistantPopupMessageBox.classList.contains('success')) {
        heatResistantPopupMessageBox.classList.add('success')
      }
      break;

    case "error":
      if (!heatResistantPopupMessageBox.classList.contains('error')) {
        heatResistantPopupMessageBox.classList.add('error')
      }
      break;
  }
}

function hideHeatResistantPopupMessage() {
  if (heatResistantPopupMessageBox) {
    heatResistantPopupMessageBox.innerHTML = "";
  }

  if (!heatResistantPopupMessageBox.classList.contains('hidden')) {
    heatResistantPopupMessageBox.classList.add('hidden')
  }

  if (heatResistantPopupMessageBox.classList.contains('success')) {
    heatResistantPopupMessageBox.classList.remove('success')
  }

  if (heatResistantPopupMessageBox.classList.contains('error')) {
    heatResistantPopupMessageBox.classList.remove('error')
  }
}

function addHeatResistantVariantsToAddressBlocks(blockIds, heatResistantVariants) {
  let cartMultiAddressList = getCartMultiAddressInfo(SINGLE_ADDRESS_KEY);
  for (const blockId of blockIds) {
    if (cartMultiAddressList[blockId]) {
      cartMultiAddressList[blockId]["cartItems"] = cartMultiAddressList[blockId]["cartItems"].concat(
        heatResistantVariants
      );
    }
  }
  saveOhnutsInfo(SINGLE_ADDRESS_KEY, JSON.stringify(cartMultiAddressList));
}

function fetchCartDataAndUpdateAddressBlockProducts(redirectURL=null) {
  fetch(window.Shopify.routes.root + 'cart.js')
	.then((response) => response.json())
	.then((responseJson) => {
		const cartToken = responseJson?.token || null;
    const cartItems = responseJson?.items || null;
		if (!cartToken || !cartItems) {
      hideHeatResistantPopup();
			return showOhnutsCustomModal(
				"Failed to retrieve cart data",
				"Cart Error",
				"Close",
				CART_REDIRECT_URL
			);
		}
		saveOhnutsInfo(SINGLE_CART_TOKEN_KEY, cartToken);
		saveOhnutsInfo(SINGLE_CART_ITEMS_KEY, JSON.stringify(cartItems));
    showHeatResistantPopupMessage(
      'Heat resistant packaging(s) added to cart',
      'success'
    );
    setTimeout(() => {
      hideHeatResistantPopup();
      if (redirectURL) {
        addClassesToElements(
          '#addAddressForShipping',
          ['loading', 'read-only']
        );
        window.location.href = redirectURL;
      }
    }, 1000)
	})
	.catch((e) => {
    hideHeatResistantPopup();
		console.error(e);
		return showOhnutsCustomModal(
			"Failed to retrieve cart data",
			"Cart Error",
			"Close",
			CART_REDIRECT_URL
		);
	});
}
